import React from "react";

// Actual brand asset (background removed) — 736x452, aspect ratio ~1.628:1
const LOGO_SRC = "/fastsend-logo.png";
const LOGO_ASPECT = 736 / 452;

/**
 * FASTSEND Icon — same brand image, cropped to icon size via CSS for
 * small nav placements. Uses the full lockup (image already includes the
 * arrow/box mark); callers that only have a small square slot will see it
 * scaled down like the wordmark.
 */
export function FastSendIcon({ size = 36, className = "", style = {} }) {
  return (
    <img
      src={LOGO_SRC}
      alt="FASTSEND"
      className={className}
      style={{
        display: "inline-block",
        verticalAlign: "middle",
        height: size,
        width: "auto",
        ...style,
      }}
    />
  );
}

/**
 * FASTSEND Full Brand Logo — renders the actual brand image everywhere.
 * `theme` no longer recolors text (the image has fixed colors); kept in the
 * prop signature so existing call sites don't need to change.
 */
export default function FastSendLogo({
  variant = "full", // "full" | "horizontal" | "icon"
  theme = "dark",
  size = "medium",  // "small" | "medium" | "large"
  showTagline = true,
  className = "",
  style = {},
}) {
  if (variant === "icon") {
    const iconSize = size === "small" ? 28 : size === "large" ? 48 : 36;
    return <FastSendIcon size={iconSize} className={className} style={style} />;
  }

  const scale = size === "small" ? 0.75 : size === "large" ? 1.35 : 1;

  if (variant === "horizontal") {
    const height = 38 * scale;
    return (
      <img
        src={LOGO_SRC}
        alt="FASTSEND — swift. secure. reliable"
        className={`fastsend-logo-horizontal ${className}`}
        style={{ display: "inline-block", verticalAlign: "middle", height, width: "auto", ...style }}
      />
    );
  }

  // "full" variant — the image already includes the tagline baked in, so
  // showTagline only affects overall height (crop tightly if hidden isn't
  // supported for a raster asset, so we just keep the full image either way).
  const width = 240 * scale;
  return (
    <div
      className={`fastsend-logo-full ${className}`}
      style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", textAlign: "center", ...style }}
    >
      <img
        src={LOGO_SRC}
        alt="FASTSEND — swift. secure. reliable"
        style={{ width, height: width / LOGO_ASPECT }}
      />
    </div>
  );
}
